export const DisplayEmailAtom = ({ email }: { email: string }) => {
  return (
    <h1 className="text-md  text-white col-span-2">{email}</h1>
  );
};
